import type { OrderItem, SelectedBundleOptionValue } from "@jti/magento";

import type { SummaryItem } from "@checkout-v2/features/ItemsSummary/ItemsSummaryView";

import { getDiscountedPrice } from "../getDiscountedPrice";

type SelectedBundleOptionValueWithLabel = SelectedBundleOptionValue & { label?: string; product_name?: string };

export const mapBundleOrderItemToSummaryItem = (
  orderItem: OrderItem,
  displayBundleSelectedItems: boolean,
  displayBundleSelectedItemsPrices: boolean,
  showPricesWithTaxExcluded: boolean
): SummaryItem => {
  const currency = orderItem.productSalePriceInclTax?.currency ?? "";

  const subItems =
    orderItem.bundle_options?.flatMap(
      (option) =>
        option.values?.map((value: SelectedBundleOptionValueWithLabel) => ({
          thumbnail: {
            src: value.presentation_info.product.small_image.url,
            alt: value.presentation_info.product.small_image.label,
          },
          quantity: value.quantity,
          title: `${option.label}${value.product_name ? `: ${value.product_name}` : ""}`,
          basePrice: {
            value: orderItem.isGift ? 0 : value.presentation_info.initial_price,
            currency,
          },
          discountedPrice: orderItem.isGift ? undefined : getDiscountedPrice(value, currency),
        })) ?? []
    ) ?? [];

  const priceToUse = showPricesWithTaxExcluded ? orderItem.productSalePrice : orderItem.productSalePriceInclTax;

  const badge = orderItem.isGift ? "cart.payment_summary.freeGift" : undefined;

  return {
    type: "bundle",
    id: orderItem.item_id || orderItem.sku,
    item: {
      title: orderItem.name,
      badge,
      thumbnail: { src: orderItem.imageUrl ?? "", alt: orderItem.name ?? "" },
      subtitle: orderItem.subtitle,
      quantity: orderItem.quantity,
      price: {
        value: priceToUse?.value ?? 0,
        currency: priceToUse?.currency ?? "",
      },
      subItems: subItems ?? [],
      areBundleItemsShown: displayBundleSelectedItems,
      areBundlePricesEnabled: displayBundleSelectedItemsPrices,
    },
  };
};
